export default "__VITE_ASSET__Cacvww2I__"